import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Loading from '~/Components/Loading';

export default function ProcuracaoStats({ estatisticas, loading }) {
  if (loading) {
    return <Loading label="Carregando estatísticas..." />;
  }

  if (!estatisticas) return null;

  const cards = [
    { label: 'Total', valor: estatisticas.total, cor: 'info' },
    { label: 'Vigentes', valor: estatisticas.vigentes, cor: 'success' },
    { label: 'Alerta', valor: estatisticas.alerta, cor: 'warning' },
    { label: 'Vencidas', valor: estatisticas.vencidas, cor: 'danger' },
    { label: 'Indeterminada', valor: estatisticas.indeterminada, cor: 'secondary' },
  ];

  return (
    <Row className="mb-2 align-items-stretch">
      {cards.map((card) => (
        <Col key={card.label} className="d-flex">
          <div
            className="d-flex align-items-center p-3 bg-white rounded shadow-sm w-100"
            style={{ borderLeft: '5px solid var(--' + card.cor + ')' }}
          >
            <div className="d-flex flex-column">
              <span
                className="font-weight-bold text-dark"
                style={{ fontSize: '1.5rem', lineHeight: 1 }}
              >
                {card.valor}
              </span>
              <span
                className="text-muted"
                style={{ fontSize: '0.8rem', marginTop: '3px' }}
              >
                {card.label}
              </span>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
}
